import React from "react";
import { Business as BusinessIcon } from "@mui/icons-material";
import { CenterAccessGrid } from "../grids";
import { SectionPaper, SectionHeader } from "../../../common/components/styled-ui-elements";

interface CenterAccessSectionProps {
  centers: any[];
  availableCenters: any[];
  onAddCenter?: (center: { code: string; name: string }) => void;
  onDeleteCenter?: (center: { code: string; name: string }) => void;
}

export const CenterAccessSection: React.FC<CenterAccessSectionProps> = ({
  centers,
  availableCenters,
  onAddCenter,
  onDeleteCenter,
}) => (
  <SectionPaper sx={{ p: 1.5, flex: 1 }}>
    <SectionHeader icon={<BusinessIcon sx={{ mr: 0.5 }} />} title="Center Access" />
    <CenterAccessGrid
      centerAccess={centers}
      availableCenters={availableCenters}
      onAdd={onAddCenter}
      onDelete={onDeleteCenter}
    />
  </SectionPaper>
);